export const paymentVerificationSubStatuses = [
  { 
    label: 'Payment Verified', 
    value: 'payment_verified'
  },
  { 
    label: 'Pending Item Completion', 
    value: 'pending_item_completion'
  },
  { 
    label: 'Item Completion unverified', 
    value: 'item_completion_unverified'
  },
];

export const awaitingResolutionSubStatuses = [
  { 
    label: 'Canceled', 
    value: 'canceled'
  },
  { 
    label: 'On Hold', 
    value: 'unsettled-items'
  },
  { 
    label: 'Partial Fulfilment', 
    value: 'partial-fulfillment'
  },
];

export const awaitingSubStatuses = [
  { 
    label: 'On its way', 
    value: 'on_its_way'
  },
  { 
    label: 'Delayed', 
    value: 'delayed'
  },
  { 
    label: 'Undelivered', 
    value: 'undelivered'
  },
];

export const inFacilitySubStatuses = [
  {
    label: 'In Bound',
    value: 'in_bound'
  },
  {
    label: 'In Facility',
    value: 'in_facility'
  },
  {
    label: 'Outbound',
    value: 'outbound'
  },
];

export const destinationWarehouseSubStatuses = [
  {
    label: 'Inbound',
    value: 'inbound'
  },
  {
    label: 'In-Warehouse',
    value: 'in_warehouse'
  },
  {
    label: 'Outbound',
    value: 'outbound'
  },
  {
    label: 'Unconfirmed',
    value: 'unconfirmed'
  },
];

export const distributionCenterSubStatuses = [
  {
    label: 'Inbound',
    value: 'inbound'
  },
  {
    label: 'In-Center',
    value: 'in_center'
  },
  {
    label: 'Return',
    value: 'return'
  },
  {
    label: 'Missing',
    value: 'missing'
  },
];
